// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2PhB2","noInteraction":"EventWrapper_noInteraction__iw6tr","pointerPassthrough":"EventWrapper_pointerPassthrough__XL_HL"};